import { render, staticRenderFns } from "./ItemHistory.vue?vue&type=template&id=c28aca76&scoped=true&"
import script from "./ItemHistory.vue?vue&type=script&lang=js&"
export * from "./ItemHistory.vue?vue&type=script&lang=js&"
import style0 from "./ItemHistory.vue?vue&type=style&index=0&id=c28aca76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28aca76",
  null
  
)

export default component.exports